import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Box,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Image from 'next/image';
import styles from './useCase.module.scss';
import { content } from '../../../../../commons/Constants/useCase';
import imgLoader from '../../../../../imgloader';

const UseCase = ({ id, productType }) => {
  const productContent = content[productType] || {};
  const productData = productContent.items || [];
  const productHeadline = productContent.headline;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box className={styles.useCaseWrapper} id={id}>
      <Container
        maxWidth={false}
        className={styles.useCaseContainer}
        disableGutters
      >
        <Box className={styles.card}>
          <Box className={styles.header}>
            <Typography className={styles.title}>{productHeadline}</Typography>
          </Box>
          <Grid
            container
            spacing={isMobile ? 4 : 8}
            className={styles.useCaseCard}
            justifyContent="center"
          >
            {productData.length > 0 ? (
              productData.map((item, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems={isMobile ? 'center' : 'flex-start'}
                    textAlign={isMobile ? 'center' : 'left'}
                  >
                    <div className={styles.imageContainer}>
                      <Image
                        src={item.image}
                        alt={item.title}
                        layout="responsive"
                        width={398}
                        height={480}
                        loader={imgLoader}
                        className={styles.imageStyle}
                        {...(item.imageProps || {})}
                      />
                    </div>
                    <Typography
                      variant="h6"
                      className={styles.titleCard}
                      sx={{ mt: 2 }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      className={styles.description}
                      sx={{ mt: 1 }}
                    >
                      {item.description}
                    </Typography>
                  </Box>
                </Grid>
              ))
            ) : (
              <Grid item>
                <Typography>Loading use cases...</Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default UseCase;
